// src/ChevronDownCircleIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ChevronDownCircleIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.64648 1.50684C4.13123 1.50684 1.27148 4.36659 1.27148 7.88184C1.27148 11.3971 4.13123 14.2568 7.64648 14.2568C11.1617 14.2568 14.0215 11.3971 14.0215 7.88184C14.0215 4.36659 11.1617 1.50684 7.64648 1.50684ZM7.64648 15.3818C3.51098 15.3818 0.146484 12.0173 0.146484 7.88184C0.146484 3.74634 3.51098 0.381836 7.64648 0.381836C11.782 0.381836 15.1465 3.74634 15.1465 7.88184C15.1465 12.0173 11.782 15.3818 7.64648 15.3818Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.64603 9.97737C7.49678 9.97737 7.35278 9.91812 7.24778 9.81162L4.64453 7.19712C4.42478 6.97662 4.42628 6.62037 4.64603 6.40137C4.86653 6.18237 5.22278 6.18237 5.44178 6.40287L7.64603 8.61837L9.85103 6.40287C10.07 6.18237 10.4263 6.18237 10.6468 6.40137C10.8665 6.62037 10.8673 6.97662 10.6483 7.19712L8.04428 9.81162C7.93928 9.91812 7.79528 9.97737 7.64603 9.97737Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
var ChevronDownCircleIcon_default = ChevronDownCircleIcon;

export {
  ChevronDownCircleIcon_default
};
